var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "USWDS Components"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34283 5.17154C9.46054 5.17154 10.448 5.43897 11.2503 5.78868C11.9908 6.11783 12.4571 6.8584 12.4571 7.66068V8.77154H4.22854V7.66754C4.22854 6.8584 4.69483 6.11783 5.4354 5.79554C6.23769 5.43897 7.22511 5.17154 8.34283 5.17154ZM2.85711 5.34297C3.6114 5.34297 4.22854 4.72583 4.22854 3.97154C4.22854 3.21725 3.6114 2.60011 2.85711 2.60011C2.10283 2.60011 1.48569 3.21725 1.48569 3.97154C1.48569 4.72583 2.10283 5.34297 2.85711 5.34297ZM3.63197 6.09725C3.37826 6.05611 3.12454 6.02868 2.85711 6.02868C2.17826 6.02868 1.53369 6.17268 0.950829 6.4264C0.443401 6.64583 0.114258 7.13954 0.114258 7.69497V8.77154H3.19997V7.66754C3.19997 7.0984 3.35769 6.56354 3.63197 6.09725ZM13.8285 5.34297C14.5828 5.34297 15.2 4.72583 15.2 3.97154C15.2 3.21725 14.5828 2.60011 13.8285 2.60011C13.0743 2.60011 12.4571 3.21725 12.4571 3.97154C12.4571 4.72583 13.0743 5.34297 13.8285 5.34297ZM16.5714 7.69497C16.5714 7.13954 16.2423 6.64583 15.7348 6.4264C15.152 6.17268 14.5074 6.02868 13.8285 6.02868C13.5611 6.02868 13.3074 6.05611 13.0537 6.09725C13.328 6.56354 13.4857 7.0984 13.4857 7.66754V8.77154H16.5714V7.69497ZM8.34283 0.542969C9.48111 0.542969 10.4 1.46183 10.4 2.60011C10.4 3.7384 9.48111 4.65725 8.34283 4.65725C7.20454 4.65725 6.28569 3.7384 6.28569 2.60011C6.28569 1.46183 7.20454 0.542969 8.34283 0.542969Z",
    fill: "#05176C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAges);
export default __webpack_public_path__ + "static/media/ages.8566aa83595fa6458f9d501aa8a4ba00.svg";
export { ForwardRef as ReactComponent };